import { attachFileAPI, BASE_URL } from "../routes/apiurls";
import { getToken } from "./pip";

// utils/uploadFile.js
const uploadFiles = async (files, role) => {
  const token = getToken(role);  
  const formData = new FormData();

  files.forEach((file) => {
    formData.append("files", file); // backend should expect "files"
  });

  const res = await fetch(BASE_URL +attachFileAPI, {
    method: "POST",
     headers: {
      Authorization: `Bearer ${token}`, // ✅ attach token
    },
    body: formData,
  });

  return res.json(); 
  /*
    Expected response:
    {
      success: true,
      data: [
        { url, type, name, size },
        { url, type, name, size }
      ]
    }
  */
};

export default uploadFiles;
